import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useFormContext } from '@afosto/app-components-react/Form';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ToggleButtonGroup from '@afosto/app-components-react/ToggleButtonGroup';
import translations from './translations';
import DateTimeGroup from '@afosto/app-components-react/DateTimeGroup';

const ShipmentFormSection = ({ locations, shipment }) => {
  const intl = useIntl();
  const { setValue, watch } = useFormContext();
  const typeValue = watch('type');

  const handleChangeType = (ev, value) => {
    setValue('type', value);
    setValue('contact', null);
    setValue('fromLocation', null);
    setValue('fromAddress', null);
    setValue('toLocation', null);
    setValue('toAddress', null);
    setValue('method', null);

    if (value === 'inbound') {
      setValue('fromType', 'address');
      setValue('toType', 'location');
    }

    if (value === 'outbound') {
      setValue('fromType', 'location');
      setValue('toType', 'address');
    }

    if (value === 'transfer') {
      setValue('fromType', 'location');
      setValue('toType', 'location');
    }
  };

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardContent>
        {!shipment?.id && (
          <>
            <ToggleButtonGroup
              name="type"
              label={intl.formatMessage(translations.fields.isOutbound.label)}
              options={[
                {
                  label: intl.formatMessage(translations.typeOptions.outbound),
                  value: 'outbound',
                },
                {
                  label: intl.formatMessage(translations.typeOptions.inbound),
                  value: 'inbound',
                },
                ...(locations?.length > 1
                  ? [
                      {
                        label: intl.formatMessage(translations.typeOptions.transfer),
                        value: 'transfer',
                      },
                    ]
                  : []),
              ]}
              onChange={handleChangeType}
            />
          </>
        )}

        {typeValue !== 'outbound' && (
          <DateTimeGroup
            name="expectedAt"
            label={intl.formatMessage(translations.fields.expectedAt.label)}
            disableFuture={false}
            disablePast
          />
        )}

        {typeValue !== 'inbound' && (
          <DateTimeGroup
            name="shipAt"
            label={intl.formatMessage(translations.fields.shipAt.label)}
            disableFuture={false}
            disablePast
          />
        )}
      </CardContent>
    </Card>
  );
};

ShipmentFormSection.propTypes = {
  locations: PropTypes.array,
  shipment: PropTypes.object,
};

ShipmentFormSection.defaultProps = {
  locations: [],
  shipment: undefined,
};

export default ShipmentFormSection;
